import { render, staticRenderFns } from "./CarouselV2.vue?vue&type=template&id=64ad2e34&scoped=true&"
import script from "./CarouselV2.vue?vue&type=script&lang=js&"
export * from "./CarouselV2.vue?vue&type=script&lang=js&"
import style0 from "./CarouselV2.vue?vue&type=style&index=0&id=64ad2e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad2e34",
  null
  
)

export default component.exports